<template>
    <vx-card :title='$t("Vehicles")'>
        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="vehicles">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div class="flex flex-wrap-reverse items-center">
                    <vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addVehiclePrompt = true">{{$t("Add")}}</vs-button>
                </div>

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ vehicles.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : vehicles.length }} of {{ vehicles.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                <vs-th sort-key="type">{{$t("Type")}}</vs-th>
                <vs-th sort-key="registration">{{$t("Registration")}}</vs-th>
                <vs-th sort-key="last_kilometers">{{$t("LastKilometers")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].name">
                        {{ data[index].name }}
                    </vs-td>

                    <vs-td :data="data[index].type">
                        {{ data[index].type }}
                    </vs-td>

                    <vs-td :data="data[index].registration">
                        {{ data[index].registration }}
                    </vs-td>

                    <vs-td :data="data[index].last_kilometers">
                        {{ data[index].last_kilometers }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup :title="$t('Add')" :active.sync="addVehiclePrompt">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="addName" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Type")}}</p>
                <vs-input v-model="addType" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Registration")}}</p>
                <vs-input v-model="addRegistration" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addVehicle">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Edit')" :active.sync="editVehiclePrompt">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="editName" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Type")}}</p>
                <vs-input v-model="editType" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Registration")}}</p>
                <vs-input v-model="editRegistration" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editVehicle">{{$t("Change")}}</vs-button>
                <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeVehicle">{{$t("Delete")}}</vs-button>
            </div>
        </vs-popup>
    </vx-card>
</template>
<script>

    export default {
        data() {
            return {
                selected: {},
                vehicles: [],

                itemsPerPage: 20,
                isMounted: false,

                addVehiclePrompt: false,
                editVehiclePrompt: false,

                addName: '',
                addType: '',
                addRegistration: '',

                editName: '',
                editType: '',
                editRegistration: ''
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {
            handleSelected(tr) {
                this.editName = tr.name;
                this.editType = tr.type;
                this.editRegistration = tr.registration;
                this.editVehiclePrompt = true;
            },
            updateVehicles() {
                const thisIns = this;
                this.$http.get('/api/v1/private_vehicle/')
                    .then(function (response) {
                        thisIns.vehicles = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addVehicle() {
                const thisIns = this;
                this.$http.post('/api/v1/private_vehicle/', {
                    name: thisIns.addName,
                    type: thisIns.addType,
                    registration: thisIns.addRegistration
                }).then(function () {
                    thisIns.updateVehicles();
                    thisIns.addVehiclePrompt = false;
                    thisIns.addName = "";
                    thisIns.addType = "";
                    thisIns.addRegistration = "";
                }).catch(function (error) {
                    thisIns.addVehiclePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            editVehicle() {
                const thisIns = this;
                this.$http.put('/api/v1/private_vehicle/' + this.selected.id, {
                    name: thisIns.editName,
                    type: thisIns.editType,
                    registration: thisIns.editRegistration
                }).then(function () {
                    thisIns.updateVehicles();
                    thisIns.editVehiclePrompt = false;
                }).catch(function (error) {
                    thisIns.editVehiclePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeVehicle() {
                const thisIns = this;
                this.$http.delete('/api/v1/private_vehicle/' + this.selected.id)
                    .then(function () {
                        thisIns.updateVehicles();
                        thisIns.editVehiclePrompt = false;
                    }).catch(function (error) {
                    thisIns.editVehiclePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        watch: {
            editVehiclePrompt: function () {
                if(!this.editVehiclePrompt){
                    this.selected = {}
                }
            }
        },
        created() {
            this.updateVehicles()
        },
        mounted() {
            this.isMounted = true;
        },
        beforeRouteLeave (to, from, next) {
            if(this.addVehiclePrompt){
                this.addVehiclePrompt = false;
                next(false)
            }else if(this.editVehiclePrompt){
                this.editVehiclePrompt = false;
                next(false)
            }else{
                next()
            }
        }
    }
</script>
